import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /~/d3-shape/src/order/reverse.js
// module id = v08i
// module chunks = 0